// src/pages/AppliAdmin/ContactForm/contactFormUtils.js

export function toContactDate(value) {
  if (!value) return null;

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  const raw = String(value).trim();

  // Compatible MySQL DATETIME : "2026-05-14 09:32:15"
  const normalized = raw.includes(" ") ? raw.replace(" ", "T") : raw;

  const date = new Date(normalized);

  return Number.isNaN(date.getTime()) ? null : date;
}

export function toDateOnly(value) {
  const date = toContactDate(value);
  if (!date) return null;

  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

export function formatDateTimeFR(value) {
  const date = toContactDate(value);
  if (!date) return "—";

  return new Intl.DateTimeFormat("fr-FR", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
}

export function formatRelativeDate(value) {
  const date = toContactDate(value);
  if (!date) return "Date inconnue";

  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMinutes = Math.floor(diffMs / 60000);

  if (diffMinutes < 1) return "À l’instant";
  if (diffMinutes < 60) return `Il y a ${diffMinutes} min`;

  const diffHours = Math.floor(diffMinutes / 60);
  if (diffHours < 24) return `Il y a ${diffHours} h`;

  const diffDays = Math.floor(diffHours / 24);
  if (diffDays === 1) return "Hier";
  if (diffDays < 7) return `Il y a ${diffDays} jours`;

  return formatDateTimeFR(date);
}

export function isToday(value) {
  const date = toContactDate(value);
  if (!date) return false;

  const now = new Date();

  return (
    date.getDate() === now.getDate() &&
    date.getMonth() === now.getMonth() &&
    date.getFullYear() === now.getFullYear()
  );
}

export function cleanMessage(value) {
  return String(value || "").trim();
}

function csvCell(value) {
  const text = String(value ?? "").replace(/\r?\n|\r/g, " ");
  return `"${text.replace(/"/g, '""')}"`;
}

export function buildContactMessagesCSV(messages = []) {
  const headers = ["id", "created_at", "name", "email", "read", "message"];

  const rows = messages.map((message) => [
    message.id,
    toContactDate(message.created_at)?.toISOString() || "",
    message.name || "",
    message.email || "",
    message.read_message ? "1" : "0",
    cleanMessage(message.message),
  ]);

  return [
    headers.map(csvCell).join(";"),
    ...rows.map((row) => row.map(csvCell).join(";")),
  ].join("\n");
}

export function downloadCSV(filename, csvContent) {
  const blob = new Blob(["\uFEFF" + csvContent], {
    type: "text/csv;charset=utf-8;",
  });

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.download = filename;
  link.click();

  URL.revokeObjectURL(url);
}